var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('main',[(_vm.averyTemplates && _vm.$route.query.format)?_c('style',{domProps:{"innerHTML":_vm._s(_vm.averyTemplates[_vm.$route.query.format].styles)}}):_vm._e(),_vm._v(" "),_c('nuxt')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }